"use strict";

var computeCopies = require('./computeCopies');
/**
 * computes the exact number to be printed given the order type & component's #up and quantity
 * @memberof ShinePrinting/Helpers
 * @param {PrintJob} printJob
 * @param {Product} product
 * @param {Component} component
 * @returns {Number}
 */


function computeExactQuantity(component) {
  var up = component.up;
  var copies = computeCopies(component);

  if (up === 'n/a') {
    return parseInt(copies, 10);
  }

  return parseInt(copies, 10) * parseInt(up, 10);
}

module.exports = computeExactQuantity;